// extracted by mini-css-extract-plugin
module.exports = {"btn":"HP8M681ynLHJVdK5V7M0e","icon":"NKWEmdUVCNYVYC5Z98gCO"};